import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { useRecoilState, useResetRecoilState, useSetRecoilState } from 'recoil';

import { getFacilityInfoApi } from '@apis/index';
import { MessageDialogState } from '@atom/DialogState';
import { FacilityState } from '@atom/FacilityState';
import { ReservationState } from '@atom/ReservationState';

import { GetFacilityInfoQueryVariables } from '../../API';

type OwnProps = {
  element: JSX.Element;
};

const ActionWithComponent = ({ element }: OwnProps): JSX.Element => {
  /* パラメータから施設IDを取得する */
  /* 共通State */
  const setMessageDialogState = useSetRecoilState(MessageDialogState);

  const location = useLocation();
  const navigate = useNavigate();

  // Recoilステート
  const resetReservationState = useResetRecoilState(ReservationState);
  const [facility, setFacility] = useRecoilState(FacilityState);
  const { facilityId } = facility;

  // クエリストリング取得
  const [searchParams] = useSearchParams();
  const facilityIdParam = searchParams.get('facilityId') ?? '';


  /* データ取得 */
  const getFacilityInfo = async (param: string) => {
    // API呼び出し
    try {
      const input: GetFacilityInfoQueryVariables = {
        input: {
          facilityId: param
        }
      };

      // データ取得
      const result = await getFacilityInfoApi(input);

      // 施設名称を設定
      setFacility({
        facilityId: param,
        facilityName: result.facilityName ?? ''
      });

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      // eslint-disable-next-line no-console
      console.error(error);

      let message = '時間をおいてから再度お試しください。解決できない場合は管理者へお問い合わせください。';
      if ('errors' in error && error.errors.length !== 0) {
        message = error.errors[0].message;
      }
      setMessageDialogState({
        open: true,
        messageData: {
          title: 'エラーが発生しました。',
          message
        }
      });
    }
  };

  const checkFacilityId = () => {
    // クエリストリングとステート両方設定されていなければホームへ遷移、
    if (facilityIdParam === '' && facilityId === '') {
      navigate('/');
      resetReservationState();
      return;
    }
    // クエリストリングがなければステートの施設IDで検索
    if (facilityIdParam === '') {
      getFacilityInfo(facilityId);
      // クエリストリングとステートのIDが異なるか、ステートに設定されていなければクエリストリングの施設IDで検索
    } else if (facilityId !== facilityIdParam || facilityId === '') {
      getFacilityInfo(facilityIdParam);
    }
  };

  // URLが変わるたびに実行
  useEffect(() => {
    checkFacilityId();
  }, [location]);

  return element;
};

export default ActionWithComponent;
